<template>
    <div :class="answer ? 'comment-answers' : 'comments-list'">
        <post-comment
                v-for="comment in getComments"
                :key="comment.id"
                :comment="comment"
                :children="getChildren(comment.id)"
                :can-answer="canAnswer"
        ></post-comment>
    </div>

</template>

<script>
    //import PostComment from "./PostComment";
    export default {
        name: 'post-comments',
        components: {
            //PostComment
            //https://vuejs.org/v2/guide/components-edge-cases.html#Circular-References-Between-Components
            //PostComment: () => import('./PostComment')
        },
        props: {
            comments: {
                Array,
                default: () => {
                    return [];
                }
            },
            answer: {
                type: Boolean,
                default: false
            },
            canAnswer: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            getComments() {
                if (!this.answer) {
                    return this.comments.filter((comment) => {
                        return comment.parent === 0
                    })
                } else {
                    return this.comments.filter((comment) => {
                        return comment.parent > 0
                    })
                }
            },
        },
        methods: {
            getChildren(id) {
                return this.comments.filter((comment) => {
                    return comment.parent === id
                })
            }
        }
    }

</script>

<style scoped>

</style>
